
import React, { useState, useEffect } from "react";

import { useSelector, useDispatch } from 'react-redux'
import _, { size } from 'lodash';
import { Bar, Doughnut, Pie, Scatter } from 'react-chartjs-2';
import { Box, Grid, Typography } from "@mui/material";
import { GetColor } from "./RefColorFunctions";
import { GetTransform } from "./RefTransformationFunctions";


const ArcListDistibution2 = (props) => {
    const safeParse = (str)=>{
        try{
            JSON.parse(str)
            return true
        }catch{
            return false;
        }
    }
    const ComponentProperties = props.ComponentProperties
    const { KeyToUse, Label, Color,ValueOrder,ValueLabels,Transform, ShowAvailable } = ComponentProperties
    const DataReportData = props.DataReportData
    const ValueOrderArray = (ValueOrder && ValueOrder.length>0 && ValueOrder.split('|')) || []
    const ValueLabelJSON = safeParse(ValueLabels) ? JSON.parse(ValueLabels):{}
    const recordCount = DataReportData.length
    const ValueArray = DataReportData.map(x=>{return {[KeyToUse]: Transform ? GetTransform(Transform,x[KeyToUse]):x[KeyToUse]}})


    const ArcSumOfValues =
        _.chain(ValueArray)
            .groupBy(KeyToUse)
            .map((value, key) => (
                { 
                    distribution: key
                    , value: value.length
                    , percentage: parseFloat((value.length / recordCount) * 100).toFixed(2)
                    , order: ValueOrderArray.indexOf(key) >=0 ? ValueOrderArray.indexOf(key) : 99 
                }))
            .value()
    
    const AllValues = Object.keys(ValueLabelJSON)
    const AllValuesData = AllValues.map((x,i)=>{ 
            let HasValues = ArcSumOfValues.filter(y=>y.distribution==x) 
            return (HasValues && HasValues.length>0)? HasValues[0] : {distribution:x, value:0, percentage:0, order: ValueOrderArray.indexOf(x) >=0 ? ValueOrderArray.indexOf(x) : 99 }
        })
    const ArcSorted = ShowAvailable ? _.sortBy(ArcSumOfValues,'order') : _.sortBy(AllValuesData,'order')
    //const ArcSorted = _.sortBy(ArcSumOfValues,'order')
    const ArcFiltered = ArcSorted.filter(x=> {return x.distribution && ((ShowAvailable && x.distribution !=='null') || !ShowAvailable) })

    const BarComponent = ({ obj }) => {
        return (
            <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={1}>
                <Grid item xs={5}>
                    <Typography variant="body2" align="right">{(ValueLabelJSON && ValueLabelJSON[String(obj.distribution)]) ? ValueLabelJSON[String(obj.distribution)] : obj.distribution}</Typography>
                </Grid>
                <Grid item xs={5}>
                    <Box sx={{ px: 2 }}>
                        <Box sx={{ width: "100%", height: "10px", borderRadius: "5px", backgroundColor: GetColor('RYGG VALUE GRADE', 0) + "AA" }}>
                            <Box sx={{ width: obj.percentage + "%", height: "100%", borderRadius: "5px", backgroundColor: GetColor('RYGG VALUE GRADE', 1) }} />
                        </Box>
                    </Box>
                </Grid>
                <Grid item xs={2}>
                    <Typography variant="body2" align="left">{Math.floor(obj.percentage)}%</Typography>
                </Grid>
            </Grid>
        )
    }


    return (
        <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={2}>
            <Grid item xs={12}>
                <Typography variant="h6" align="center">{Label}</Typography>
            </Grid>
            <Grid item xs={12}>
                <Grid container direction="row" alignItems="center" justifyContent={"center"} spacing={1}>
                    {
                        ArcFiltered.map(x => {

                                return (
                                    <Grid item xs={12}>
                                        <BarComponent obj={x} />
                                    </Grid>
                                )
                            }
                        )
                    }
                </Grid>
            </Grid>

        </Grid>
    )
}

export default ArcListDistibution2